import React from 'react';

import TableRowContainer from './TableRowContainer';
import TableCell from './TableCell';

// eslint-disable-next-line
const TableHeader = ({ disableCancel }) => (
  <TableRowContainer header>
    {/* <TableCell>LIVE</TableCell> */}
    <TableCell flex={4}>CAMPAIGN NAME</TableCell>
    <TableCell flex={3.5}>STATE(S)</TableCell>
    <TableCell flex={2}>START DATE</TableCell>
    <TableCell flex={2}>END DATE</TableCell>
    <TableCell center flex={1}>PREVIEW</TableCell>
    <TableCell center flex={1}>{disableCancel ? null : 'CANCEL'}</TableCell>
    <TableCell flex={1.5}>STATUS</TableCell>
  </TableRowContainer>
);

export default TableHeader;




// WEBPACK FOOTER //
// ./client/Dashboard/components/TableHeader.js